import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import { Observer } from 'mobx-react-lite'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { Button, toastStore } from 'shared/ui'
import { NumberSetting } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall/ui/ForwardCallActionEditContent/NumberSetting/NumberSetting'
import { NumberSettingStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall/ui/ForwardCallActionEditContent/NumberSetting/store/NumberSettingStore'

export class SetUpNumberSettingsStore {
  modalId
  modalNumberSettingStore: NumberSettingStore
  constructor(
    readonly numberSettingStore: NumberSettingStore,
    private onSuccess: (store: NumberSettingStore) => void
  ) {
    this.modalId = nanoid()
    this.modalNumberSettingStore = new NumberSettingStore(
      numberSettingStore.entities,
      numberSettingStore.phone,
      numberSettingStore.params,
      numberSettingStore.destination
    )

    modalStore.addModal({
      id: this.modalId,
      title: 'Set up',
      ModalContent: () => <NumberSetting store={this.modalNumberSettingStore} />,
      ModalActions: () => (
        <Observer>
          {() => (
            <Button
              contained={'primary'}
              size={'medium'}
              text={'Save'}
              onClick={this.onSave}
              disabled={this.disabledSave}
            />
          )}
        </Observer>
      ),
    })
    makeAutoObservable(this)
  }

  onSave = () => {
    const isValid = this.modalNumberSettingStore.validate()
    if (isValid) {
      toastStore.add({
        type: 'info',
        title: 'Call forwarding enabled',
      })
      this.onSuccess(this.modalNumberSettingStore)
      modalStore.closeModal(this.modalId)
    }
  }
  get disabledSave() {
    return (
      JSON.stringify(this.modalNumberSettingStore.params) ===
      JSON.stringify(this.numberSettingStore.params)
    )
  }
}
